import React from 'react';
import  FacebookCircularProgress  from '../Elementos/FacebookCircularProgress';
import { Page, Text, View, Document, StyleSheet, Image as ImagePdf, Font, usePDF } from '@react-pdf/renderer';
import { IconButton, Grid } from '@material-ui/core';
import { GetApp as GetAppIcon } from '@material-ui/icons';

const PdfOt = ({data, handleClickPdf, InfoEmpresa})=>{

    Font.register({family: 'OpenSans', fonts: [
        { src: 'fonts/OpenSans-Light.ttf' }, // font-style: normal, font-weight: normal
        { src: 'fonts/OpenSans-Italic.ttf', fontStyle: 'italic' },
        { src: 'fonts/OpenSans-Bold.ttf', fontWeight: 'bold' },
        { src: 'fonts/OpenSans-Regular.ttf', fontWeight: 'normal' },
        { src: 'fonts/OpenSans-Regular.ttf', fontWeight: 'black' },
    ]});

    const styles = StyleSheet.create({
        container:{
            width:'100vw', 
            height:'100vh',
            margin:'0px auto',
            display:'flex',
            justifyContent:'flex-start',
            alignContent:'flex-start',
            alignItems:'flex-start',
            padding:'15px 30px',
            fontSize:8,
        },
        image: {
            objectFit:'container',
            height:'99%',
        },
        header1:{
            width:'100%',
            height:15, 
            display:'flex',
            flexDirection:'row',
        },
        header1_1:{
            width:'40%'
        },
        header1_2:{
            width:'60%',
            paddingLeft:27,
        },
        header2:{
            width:'100%',
            height:80, 
            display:'flex',
            flexDirection:'row',
        },
        subheader2_1:{
            width:'40%',
            height:'100%',
            padding:10,
            display:'flex',
            justifyContent:'center',
            flexDirection:'row',
            alignItems:'center'
        },
        subheader2_2:{
            borderLeftWidth:1,
            borderLeftStyle:'solid',
            borderLeftColor:'gray',
            width:'60%',
            height:'100%',
            paddingLeft:20,
        },
        pPadre:{
            color:'#005596',
            fontFamily:'OpenSans',
            fontSize: 13,
            fontWeight:'bold',
            margin:"2px 2px 20px 5px"
        },
        viewText:{
            display:'flex',
            flexDirection:'row',
            height:20,
            paddingLeft:5
        },
        pHijos:{
            fontWeight: 'extrabold',
            margin:"4px 0px 0px 4px",
            color:'#000'
        },
        logoSpan:{  
            width:12,
            height:12,
            marginTop:2,
            marginRight:3,
        },
        header3:{
            fontSize:14,
            width:'100%', 
            textAlign:'center',
            height:20,
            paddingTop:3
        },
        header4:{
            fontSize:12,
            width:'100%', 
            textAlign:'left',
            border:'1px solid gray',
            paddingLeft:10,
            height:20,
            paddingTop:3
        },
        header5:{
            marginTop:-1,
            fontSize:10,
            width:'100%', 
            textAlign:'left',
            borderLeftWidth:1,
            borderLeftStyle:'solid',
            borderLeftColor:'gray',
            borderRightWidth:1,
            borderRightStyle:'solid',
            borderRightColor:'gray',
            borderBottomWidth:1,
            borderBottomStyle:'solid',
            borderBottomColor:'gray',
            height:15,
            display:'flex', 
            flexDirection:'row'
        },
        header5_1:{
            width:'30%',
            alignSelf: 'center',
            borderRightWidth:1,
            borderRightStyle:'solid',
            borderRightColor:'gray',
            textAlign:'left',
            paddingLeft:10,
            fontFamily:'OpenSans',
            fontWeight:'bold'
        },
        header5_2:{
            alignSelf: 'center',
            width:'70%',
            textAlign:'left',
            paddingLeft:10,
            fontFamily:'OpenSans',
            fontWeight:'black'
        },
        header6:{
            paddingTop:9,
            fontSize:10,
            width:'100%', 
            textAlign:'left',
            height:22,
            paddingLeft:10,
        },
        header7:{
            fontSize:10,
            width:'100%', 
            textAlign:'left',
            border:'1px solid gray',
            height:20,
            display:'flex', 
            flexDirection:'row',
        },
        header7_1:{
            alignSelf:'center',
            width:'35%',
            paddingLeft:5
        },
        header7_2:{
            alignSelf:'center',
            borderLeftWidth:1,
            borderLeftStyle:'solid',
            borderLeftColor:'gray',
            borderRightWidth:1,
            borderRightStyle:'solid',
            borderRightColor:'gray',
            width:'35%',
            height:'100%',
            paddingLeft:5
        },
        header7_3:{
            alignSelf:'center',
            width:'30%',
            paddingLeft:5
        },
        header8:{
            marginTop:-1,
            width:'100%', 
            textAlign:'left',
            border:'1px solid gray',
            height:15,
            borderLeftWidth:1,
            borderLeftStyle:'solid',
            borderLeftColor:'gray',
            borderRightWidth:1,
            borderRightStyle:'solid',
            borderRightColor:'gray',
            borderBottomWidth:1,
            borderBottomStyle:'solid',
            borderBottomColor:'gray',
            display:'flex', 
            flexDirection:'row',
        },
        header9:{
            marginTop:-1,
            fontSize:9,
            width:'100%', 
            textAlign:'left',
            borderLeftWidth:1,
            borderLeftStyle:'solid',
            borderLeftColor:'gray',
            borderRightWidth:1,
            borderRightStyle:'solid',
            borderRightColor:'gray',
            borderBottomWidth:1,
            borderBottomStyle:'solid',
            borderBottomColor:'gray',
            display:'flex', 
            flexDirection:'column',
            padding:5
        },
        elemento:{
            width:'100%',
            height:14,
        },
        elementoBank:{
            fontSize:8,
            width:'100%',
            height:14,
        },
        firmas:{
            fontSize:10,
            width:'100%',
            height:60,
            display:'flex',
            flexDirection:'row',
        },
        firma1:{
            width:'50%',
            textAlign:'center',
        }
        
    });

    const MyDoc = (
        <Document>
            <Page size="A4" orientation="portrait" wrap>
                <View style={styles.container} wrap>
                    <View style={styles.header2}>
                        <View style={{height:20}}>

                        </View>
                        <View style={styles.subheader2_1}>
                            <ImagePdf source={InfoEmpresa.urlLogoFactura} style={styles.image} />
                        </View>
                        <View style={styles.subheader2_2}>
                            <View style={{width:'100%', textAlign:'start'}}>
                                <Text style={styles.pPadre}>{InfoEmpresa.Empresa}</Text>
                            </View>
                            <View style={styles.viewText}>
                                <ImagePdf source='iconos/ubicacion.png' style={styles.logoSpan}/>
                                <View>
                                    <Text style={styles.pHijos}>{ InfoEmpresa.Direccion }</Text>
                                </View>
                            </View>
                            <View style={styles.viewText}>
                                <ImagePdf source='iconos/mail.png' style={styles.logoSpan}/>
                                <View>
                                    <Text style={styles.pHijos}>{ InfoEmpresa.EmailInfo }</Text>
                                </View>
                            </View>
                            <View style={styles.viewText}>
                                <ImagePdf source='iconos/whatsapp.png' style={styles.logoSpan}/>
                                <View>
                                    <Text style={styles.pHijos}>{ InfoEmpresa.Telefono }</Text>
                                </View>
                            </View>
                            <View style={styles.viewText}>
                                <ImagePdf source='iconos/web.png' style={styles.logoSpan}/>
                                <View>
                                    <Text style={styles.pHijos}>{ InfoEmpresa.PaginaWeb }</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={{height:20}}>

                    </View>
                    <View style={styles.header3}>
                        <Text>HOJA DE ORDEN DE TRABAJO N° {data.numOT}</Text>
                    </View>
                    <View style={{height:20}}>

                    </View>
                    <View style={styles.header4}>
                        <Text>DATOS DEL CLIENTE</Text>
                    </View>
                    <View style={styles.header5}>
                        <View style={styles.header5_1}>
                            <Text>NOMBRES Y APELLIDOS</Text>
                        </View>
                        <View style={styles.header5_2}>
                            <Text> {data.Nombres}</Text>
                        </View>
                    </View>
                    <View style={styles.header5}>
                        <View style={styles.header5_1}>
                            <Text>TELEFONO</Text>
                        </View>
                        <View style={styles.header5_2}>
                            <Text> {data.Celular}</Text>
                        </View>
                    </View>
                    <View style={styles.header5}>
                        <View style={styles.header5_1}>
                            <Text>DIRECCION</Text>
                        </View>
                        <View style={styles.header5_2}>
                            <Text> {data.Direccion ? data.Direccion : 'NO EXISTE'}</Text>
                        </View>
                    </View>
                    <View style={styles.header5}>
                        <View style={styles.header5_1}>
                            <Text>OT PROGRAMADA:</Text>
                        </View>
                        <View style={styles.header5_2}>
                            <Text> {`${data.Fecha} -${data.Hora ? data.Hora: ''}  `}</Text>
                        </View>
                    </View>
                    <View style={styles.header5}>
                        <View style={styles.header5_1}>
                            <Text>TIPO</Text>
                        </View>
                        <View style={styles.header5_2}>
                            <Text> {data.Tipo}</Text>
                        </View>
                    </View>
                    {
                        data.Tipo === 'SOPORTE' ?
                        <View>
                            <View style={styles.header5}>
                                <View style={styles.header5_1}>
                                    <Text>DETALLE</Text>
                                </View>
                                <View style={styles.header5_2}>
                                    <Text> {data.Detalle}</Text>
                                </View>
                                {
                                    data.Detalle === 'Cambio ONT' ?
                                    <View>
                                        <View style={styles.header5}>
                                            <View style={styles.header5_1}>
                                                <Text>ONU</Text>
                                            </View>
                                            <View style={styles.header5_2}>
                                                <Text> {data.Onu}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.header5}>
                                            <View style={styles.header5_1}>
                                                <Text>MAC</Text>
                                            </View>
                                            <View style={styles.header5_2}>
                                                <Text> {data.MacOnu}</Text>
                                            </View>
                                        </View>
                                    </View>
                                    : null
                                }
                                 {
                                    data.Detalle === 'Cambio Router' ?
                                    <View>
                                        <View style={styles.header5}>
                                            <View style={styles.header5_1}>
                                                <Text>ROUTER</Text>
                                            </View>
                                            <View style={styles.header5_2}>
                                                <Text> {data.Router}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.header5}>
                                            <View style={styles.header5_1}>
                                                <Text>MAC</Text>
                                            </View>
                                            <View style={styles.header5_2}>
                                                <Text> {data.MacRouter}</Text>
                                            </View>
                                        </View>
                                    </View>
                                    : null
                                }
                                 {
                                    data.Detalle === 'Cambio CPE' ?
                                    <View>
                                        <View style={styles.header5}>
                                            <View style={styles.header5_1}>
                                                <Text>CPE</Text>
                                            </View>
                                            <View style={styles.header5_2}>
                                                <Text> {data.Modelo}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.header5}>
                                            <View style={styles.header5_1}>
                                                <Text>MAC</Text>
                                            </View>
                                            <View style={styles.header5_2}>
                                                <Text> {data.MacModelo}</Text>
                                            </View>
                                        </View>
                                    </View>
                                    : null
                                }
                            </View>
                        </View> : null
                        
                    }
                    <View style={{height:20}}>

                    </View>
                    
                    <View style={styles.header4}>
                        <Text>Observacion</Text>
                    </View>                
                    <View style={styles.header9}>
                        <View style={styles.elemento}>
                            <Text>
                                {data.Observacion}
                            </Text>
                        </View>
                    </View>
                    <View style={{height:20}}>

                    </View>
                    <View style={styles.header4}>
                        <Text>Horarios</Text>
                    </View>
                    <View style={styles.header9}>
                        <View style={styles.elemento}><Text>
                            - Tel. Soporte Tecnico: { InfoEmpresa.Telefono }
                        </Text></View>
                        <View style={styles.elemento}><Text>
                            - Tel. Ventas: { InfoEmpresa.Telefono }
                        </Text></View>
                        <View style={styles.elemento}><Text>
                            - Lunes a Viernes: 9:00 AM a 6:00 PM
                        </Text></View>
                        <View style={styles.elemento}><Text>
                            - Sabado: 9:00 AM a 12:00 PM
                        </Text></View>
                    </View>
                    <View style={{height:350}}>

                    </View>
                    <View style={styles.firmas}>
                        <View style={styles.firma1}>
                            <Text>
                                _________________________________________
                            </Text>
                            <Text>
                                {data.Nombres}
                            </Text>
                            <Text>
                                C.I.: {data.CI}
                            </Text>
                            <Text style={{fontSize:8}}>CLIENTE</Text>
                        </View>
                        <View style={styles.firma1}>
                        <Text>
                                _________________________________________
                            </Text>
                            <Text>
                                {data.Tecnico ? data.Tecnico : 'JOAO CASTILLO' }
                            </Text>
                            <Text style={{fontSize:8}}>TÉCNICO</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );

    const [ instance ] = usePDF({ document: MyDoc });

    if (instance.loading) return (
        <Grid container justifyContent='flex-start' alignItems='flex-start' style={{width: '100%', height:'100%'}}>
           <Grid item style={{alignSelf: 'center', padding:1}}>
                <FacebookCircularProgress size={22} />
            </Grid>
        </Grid>
    );

    if (instance.error) return <div>Something went wrong: {instance.error}</div>;


    return (
        <Grid container justifyContent='flex-start' alignItems='flex-start' style={{width: '100%', height:'100%'}}>
            <Grid item style={{alignSelf: 'center'}}>
                <IconButton href={instance.url} target='_blank' onClick={handleClickPdf} size='small'  color='secondary'>
                    <GetAppIcon />
                </IconButton>
            </Grid>
        </Grid>
    );
};

export default PdfOt;